import { environmentHttpClient } from "client/Api/httpClient";

export enum Theme {
	System = 0,
	Light = 1,
	Dark = 2
}

export function setUserTheme(
	theme: Theme,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		`/UserTheme?theme=${theme}`,
		undefined,
		{ signal }
	);
};